import urlJoin from 'url-join';

import { getENV } from '@libs/common-next';

function createAuth0BrowserClient(basePath: string) {
    return {
        async post<TBody>(pathname: string, body: TBody) {
            const response = await fetch(urlJoin(basePath, pathname), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });

            const message = await response.text();

            if (!response.ok) {
                throw new Error(`Auth0 request failed: ${response.status}`);
            }

            return message;
        },
    };
}

let _auth0Client: ReturnType<typeof createAuth0BrowserClient> | null = null;

function initAuth0Client() {
    if (!_auth0Client) {
        const domain = getENV('NEXT_PUBLIC_AUTH0_DOMAIN');

        _auth0Client = createAuth0BrowserClient(`https://${domain}`);
    }

    return _auth0Client;
}

export const auth0Client = new Proxy({} as ReturnType<typeof createAuth0BrowserClient>, {
    get(_target, prop) {
        return initAuth0Client()[prop as keyof typeof _auth0Client];
    },
});
